import {Button, Card, Space} from 'antd';
import styled from 'styled-components';

export const COLOR_TEXT_GREY = '#84868C';
export const COLOR_TEXT_DESCRIPTION = '#5C5F66';
export const COLOR_LIGHT_GREY = '#D4D6D9';
export const COLOR_TEXT_TIP = '#84868C';
export const COLOR_PRIMARY = '#2468F2';
export const COLOR_WARNING = '#FF9326';
export const COLOR_DANGER = '#F33E3E';
export const COLOR_HIGHT = '#8C66FF';

export const SCContainer = styled.div`
    height: ${(props: any) => {
        if (props.$height !== undefined) {
            return props.$height;
        }
        return props.$iframe
            ? 'auto' : '100%';
    }};
    background: ${(props: any) => {
        return props.$iframe
            ? '#fff' : 'none';
    }};
    padding-bottom: ${(props: any) => {
        return props.$iframe
            ? 0 : '1.6rem';
    }};
    @media (max-width: 600px) {
        padding-bottom: 6rem;
    }
`;

export const SCBgGrey = styled.div`
    background-color: #f4f4f4;
    padding: 12px;
    height: 100vh;
    padding-bottom: 10rem;
    overflow-y: scroll;
    .adm-list {
        background-color: #f4f4f4;
    }
`;

export const SCDanger = styled.span`
    color: ${COLOR_DANGER};
`;

export const SCWarning = styled.span`
    color: ${COLOR_WARNING};
`;

export const SCFormTip = styled.div`
    color: ${COLOR_TEXT_GREY};
    line-height: 18px;
    font-size: 1.4rem;
    margin: 0 0 0.8rem 0;
    a {
        margin-left: 0.8rem;
    }
`;

export const SCAgreementTip = styled.div`
    font-size: 1.4rem;
    color: ${COLOR_TEXT_GREY};
`;

export const SCBottomFix = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1.6rem;
    background: #fff;
`;

export const SCFooterButton = styled(Button)`
    min-width: 40vw;
`;

export const SCFooter = styled(Space)`
    display: flex;
    justify-content: start;
    margin-top: 1.6rem;
    @media (max-width: 600px) {
        justify-content: center;
    }
`;

export const SCFooterContainer = styled.div`
    /* padding-bottom: 7rem; */
`;

export const SCCenterTitle = styled.h2`
    font-family: PingFangSC-Medium;
    font-size: 1.6rem;
    color: #151b26;
    line-height: 2.4rem;
    font-weight: 500;
`;

export const SCLegendTitle = styled.div`
    border-left: 4px solid ${COLOR_PRIMARY};
    padding-left: 0.8rem;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1.6rem;
`;

export const FormCard = styled(Card)``;

export const SCSelectItem = styled.div`
    font-size: 1.4rem;
    border-bottom: 1px solid #d6d6d6;
`;

export const SCCenterLoading = styled.div`
    width: inherit;
    text-align: center;
`;

export const SCPicContainer = styled.div`
    padding: 0.8rem;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
    width: fit-content;
`;

export const SCUploadBtn = styled.div`
    padding: 0.8rem;
    width: 8rem;
    height: 8rem;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: ${COLOR_TEXT_DESCRIPTION};
`;

export const SCLineText = styled.span`
    // 移动端响应式兼容
    @media (max-width: 600px) {
        line-height: 3rem;
        font-size: 1.4rem;
    }
`;
